import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData, deleteIdData } from "../../../lib/class";

export default function AdminClassList() {
  const [classlist, setClassList] = useState([]);

  const [filteredClasslist, setFilteredClasslist] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Handle search query and filter resources
  useEffect(() => {
    const filterData = () => {
      const filtered = classlist.filter((classItem) => {
        return (
          classItem.class_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          classItem.grade.toString().includes(searchQuery)
        );
      });
      setFilteredClasslist(filtered);
    };

    filterData();
  }, [searchQuery, classlist]);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      GetData();
      //console.log("Delete",id);
      //router.refresh();
    }
  };

  async function GetData() {
    const clas = await getAllData();
    setClassList(clas);
    setFilteredClasslist(clas);
    console.log("class", clas);
  }

  useEffect(() => {
    GetData();
  }, []);

  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex p-2 justify-content-between align-items-center">
            <div className="d-flex p-2">
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }

  return (
    <div className="col-xl-12 col-md-12">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          {essentialheader(
            "Class List",
            "Create New Class",
            "/admin/admin-classedit/Add"
          )}
          <div className="d-flex justify-content-start ms-3">
              <input
                type="text"
                className="form-control w-25 me-2"
                placeholder="Search class list..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ border: "1px solid #808080" }}
              />
          </div>
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              {/* Invoice info */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th style={{ width: "30%" }}>Class Name</th>
                    <th>Grade</th>
                    <th>Is Active</th>
                    <th style={{ width: "25%" }}>&nbsp;</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClasslist.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>
                          <Link to="#" className="invoice-no">
                            {data.id}
                          </Link>
                        </td>
                        <td>{data.class_name}</td>
                        <td>{data.grade}</td>
                        <td>
                          {data.isActive ? (
                            <span className="badge info-low">True</span>
                          ) : (
                            <span className="badge info-high">False</span>
                          )}
                        </td>
                        <td>
                          <div className="active-change-plan grad-border hvr-sweep-to-right d-flex  justify-content-end">
                            <Link
                              to={`/admin/admin-studenttoclass/${data.id}`}
                              className="btn btn-primary"
                            >
                              Add To Student
                            </Link>
                          </div>
                        </td>
                        <td>
                          <div className="profile-share d-flex align-items-center justify-content-end">
                            <Link
                              to={`/admin/admin-classedit/${data.id}`}
                              className="btn btn-success btn-sm"
                            >
                              Update
                            </Link>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(data.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* Invoice info */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
